export default __webpack_public_path__ + "static/media/car-with-lady.d5d0ea38.svg";